import { render, staticRenderFns } from "./parameter.vue?vue&type=template&id=2dbee79f&scoped=true&"
import script from "./parameter.vue?vue&type=script&lang=js&"
export * from "./parameter.vue?vue&type=script&lang=js&"
import style0 from "./parameter.vue?vue&type=style&index=0&id=2dbee79f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbee79f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
